import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {EffectsModule} from '@ngrx/effects';
import {StoreModule} from '@ngrx/store';
import {ContextDataEffects} from './context-data.effects';
import * as fromContext from './context-data.reducer';
import {contextDataKey} from './context-data.selectors';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature({
      name: contextDataKey,
      reducer: fromContext.reducer,
    }),
    EffectsModule.forFeature([ContextDataEffects]),
  ],
})
export class ContextDataModule {}
